import React from 'react';
import { Form } from 'react-bootstrap';

type Props = {
    type?: string,
    register?: string,
    defaultValue?: any,
    onChange?: any,
    disabled?: boolean,
}

const Input = (props: Props) => {
    return (
        <Form.Control { ...props } />
    )
}

export default Input;